import React, { useContext, useEffect, useState } from 'react';
import './SantaSleigh.css';
import Santa from '../../../Assets/santa.png'
import UserContext from '../../../Context/UserContext';
// Beautiful transparent PNG of Santa, sleigh and 8 reindeer
// Source: https://www.cleanpng.com (free for personal/commercial use)
const SANTA_IMAGE = Santa
  

const SantaSleighRealistic = () => {
const [isFlying, setIsFlying] = useState(false);

    

  
  const launchSanta = () => {
    setIsFlying(true);
    setTimeout(() => setIsFlying(false), 12000); // 12-second flight
  };

  useEffect(() => {
    // First appearance: 5–25 seconds after page load
    const first = setTimeout(launchSanta, Math.random() * 6000 + 5000);

    // Then every 45–150 seconds
    const interval = setInterval(() => {
      const delay = Math.random() * 105000 + 45000;
      setTimeout(launchSanta, delay);
    }, 120000);

    return () => {
      clearTimeout(first);
      clearInterval(interval);
    };
  }, []);

  // Randomly flip direction (sometimes left-to-right, sometimes right-to-left)
  const direction = Math.random() > 0.5 ? 'normal' : 'reverse';
  const {personalizeValue} = useContext(UserContext)
  
  if(!personalizeValue.santa){return null;}
  if (!isFlying) return null;

  return (
    <div className={`santa-realistic-container ${direction}`}>
      <img
        src={SANTA_IMAGE}
        alt="Santa Claus flying with reindeer"
        className="santa-realistic-image"
      />
    </div>
  );
};

export default SantaSleighRealistic;